module.exports = __webpack_public_path__ + "files/9f2f4cdae93ebe73045aec37eb210fda.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/ppt.png
// module id = 413
// module chunks = 76